import { Component, Input } from '@angular/core';

@Component({
    selector: 'tam-grid-pinned-row',
    templateUrl: './custom-pinned-row-render.component.html',
    styleUrls: ['./custom-pinned-row-render.component.scss']
})

export class ServerSideGridPinnedRowComponent {
    @Input() params;
    @Input() subject$;

    constructor(
    ) { }

    closeGroup() {
        this.subject$.next(this.params.threadEntryType.name);
    }
}
